import React, { useEffect } from "react";
import BasePage from "components/BasePage";
import BlockAboutCards from "./components/BlockAboutCards";
import BlockAboutFindACoach from "./components/BlockAboutFindACoach";
import BlockAboutOwners from "./components/BlockAboutOwners";
import BlockOurValues from "./components/BlockOurValues";
import "./style.scss";

export default function PageAboutUs() {
  useEffect(() => {
    const main = document.querySelector(".main");
    main?.classList.add("bg-white");
    return () => main?.classList.remove("bg-white");
  }, []);

  return (
    <BasePage className="page-about-us">
      <BlockAboutOwners />
      <BlockAboutCards />
      <BlockOurValues />
      <BlockAboutFindACoach />
    </BasePage>
  );
}
